import { Container, Divider, Heading } from "@chakra-ui/react";
import CardForm from "components/ui/CardForm";
import HeaderBarInternal from "components/ui/HeaderBarInternal";
import { useResource } from "hooks/useResource";
import { useParams } from "react-router-dom";
import PersonForm from "../components/PersonForm";

export default function PageEditPerson() {
  const { id } = useParams();
  const { data: person } = useResource({
    id: id as string,
    resourceName: "person",
    path: "people",
  });

  return (
    <>
      <HeaderBarInternal title="Editar parlamentar" backTo="/parlamentares" />
      <Divider />

      <Container variant="internal" flexDirection="column">
        <Heading as="h1" size="h1">
          Dados do parlamentar
          <span>Edite os dados do parlamentar</span>
        </Heading>

        <CardForm>{person && <PersonForm person={person} />}</CardForm>
      </Container>
    </>
  );
}
